export default 
{
  type: "form-thankyou",
  style: "",
  data: {
    contentID: "hidden-thankyou-section",
    paddingLeft: 10,
    paddingTop: 36,
    paddingBottom: 36,
    paddingRight: 10,
    html: "<p><span style=\"font-size:24px;\">Thankyou!</span></p>",
  },
  children: [],
};
